import {Object3D} from '@wonderlandengine/api';
import {vec3} from 'gl-matrix';

const tempVec = vec3.create();

/**
 * camera-shake
 */
export class CameraShake {
    /* Properties that are configurable in the editor */

    strength = 0.008;
    duration = 0.5;
    count = 5;

    startPos = vec3.create();
    cur = vec3.create();
    targetOffset = vec3.create();

    time = 0;
    shakes = 0;

    constructor() {
        this.shakes = this.count;
        vec3.copy(this.cur, this.startPos);
        this.selectNextTarget();

        this.targetOffset[0] = 0;
        this.targetOffset[1] = 0;
    }

    selectNextTarget() {
        if (this.shakes >= this.count - 1) {
            /* Return to 0 offset */
            this.targetOffset[0] = this.targetOffset[1] = 0;
        } else {
            this.targetOffset[0] = (Math.random() - 0.5) * this.strength;
            this.targetOffset[1] = (Math.random() - 0.5) * this.strength;
        }
    }

    shake(): void {
        this.time = 0;
        this.shakes = 0;
        vec3.copy(this.cur, this.startPos);
        this.selectNextTarget();
    }

    update(o: Object3D, dt: number) {
        if (this.shakes >= this.count) {
            o.resetPosition();
            return;
        }
        this.time += dt;

        const f = Math.min((this.time / this.duration) * this.count, 1);
        vec3.lerp(tempVec, this.cur, this.targetOffset, f);
        o.setPositionLocal(tempVec);

        const reached = f >= 1.0;
        if (reached) {
            vec3.copy(this.cur, tempVec);
            ++this.shakes;
            this.time -= this.duration;
            this.selectNextTarget();
        }
    }
}
